/**
 * La búsqueda del listado de clientes vive en la URL.
 *
 * Myriam, 31-oct-2026: "si doy en Ver detalle al salir me saca de la búsqueda y
 * me sale el listado completo de clientes. Debería quedarse en mi búsqueda hasta
 * que yo me salga o la modifique."
 *
 * Estaba solo en el estado de la pantalla, y ese estado muere al abrir la ficha.
 * En la URL sobrevive a la ficha, al botón Volver y a la flecha del navegador, y
 * entrar por el menú desde otra pantalla la deja vacía, que es "salirse".
 */
const VACIA = { buscar: '', tipo: 'all', estado: 'all', pagina: 1 };

export function leerListaClientes(params) {
  const pagina = parseInt(params.get('pagina'), 10);
  return {
    buscar: params.get('buscar') || VACIA.buscar,
    tipo: params.get('tipo') || VACIA.tipo,
    estado: params.get('estado') || VACIA.estado,
    pagina: pagina > 0 ? pagina : VACIA.pagina,
  };
}

/** Solo lo que no sea el valor de siempre: `/clients` se queda como `/clients`. */
export function parametrosListaClientes({ buscar, tipo, estado, pagina }) {
  const params = new URLSearchParams();
  if (buscar) params.set('buscar', buscar);
  if (tipo !== VACIA.tipo) params.set('tipo', tipo);
  if (estado !== VACIA.estado) params.set('estado', estado);
  if (pagina !== VACIA.pagina) params.set('pagina', String(pagina));
  return params.toString();
}

export function enlaceListaClientes(lista) {
  const parametros = parametrosListaClientes(lista);
  return parametros ? `/clients?${parametros}` : '/clients';
}
